const mutations = {
    switchLoading (state, value) {
        state.isLoading = value
  },
    switchLoadingUnity (state, value) {
      state.isLoading = value
  },

    resetState (state) {
        state.env = process.env.NODE_ENV
        state.baseApiUrl = process.env.VUE_APP_BASE_API_URL
        state.stateKey = 1
        state.isLoading = false
        state.isLoadingUnity = false
        state.baseImgPath = process.env.VUE_APP_IMAGES_BASE_PATH
    }
};

export default mutations;
